import { useEffect, useState } from 'react';

export default function VerifyEmailChangePage() {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('Verifying your email change...');
  const [details, setDetails] = useState<{ oldEmail?: string; newEmail?: string }>({});

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      setStatus('error');
      setMessage('Missing verification token. Please check your email link.');
      return;
    }

    const verifyEmail = async () => {
      try {
        const response = await fetch('/api/verify-email-change', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token })
        });

        const data = await response.json();

        if (data.success) {
          setStatus('success');
          setMessage('Your email has been changed successfully!');
          setDetails({ oldEmail: data.oldEmail, newEmail: data.newEmail });

          // Redirect to dashboard after 3 seconds
          setTimeout(() => {
            window.location.href = '/dashboard?emailChanged=true';
          }, 3000);
        } else {
          setStatus('error');
          setMessage(data.error || 'Failed to verify email change');
        }
      } catch (error) {
        setStatus('error');
        setMessage('An error occurred while verifying your email change');
      }
    };

    verifyEmail();
  }, []);

  const goToDashboard = () => {
    window.location.href = '/dashboard';
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1f2937 0%, #111827 50%, #1f2937 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '16px'
    }}>
      <div style={{
        backgroundColor: '#1f2937',
        borderRadius: '12px',
        padding: '32px',
        maxWidth: '420px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
        border: '1px solid rgba(212, 175, 55, 0.2)'
      }}>
        {status === 'loading' && (
          <>
            <div style={{
              width: '64px', height: '64px', border: '4px solid #D4AF37',
              borderTopColor: 'transparent', borderRadius: '50%',
              margin: '0 auto 24px', animation: 'spin 1s linear infinite'
            }} />
            <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#fff', marginBottom: '8px' }}>
              Verifying Email
            </h1>
            <p style={{ color: '#9ca3af' }}>{message}</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: '64px', marginBottom: '24px' }}>✅</div>
            <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#4ade80', marginBottom: '16px' }}>
              {message}
            </h1>
            {details.oldEmail && details.newEmail && (
              <div style={{
                backgroundColor: 'rgba(55, 65, 81, 0.5)', borderRadius: '8px',
                padding: '16px', marginBottom: '24px', textAlign: 'left'
              }}>
                <p style={{ color: '#9ca3af', fontSize: '14px', margin: '0 0 4px' }}>Previous email:</p>
                <p style={{ color: '#fff', margin: '0 0 12px' }}>{details.oldEmail}</p>
                <p style={{ color: '#9ca3af', fontSize: '14px', margin: '0 0 4px' }}>New email:</p>
                <p style={{ color: '#D4AF37', fontWeight: '600', margin: 0 }}>{details.newEmail}</p>
              </div>
            )}
            <p style={{ color: '#9ca3af', fontSize: '14px' }}>Redirecting to dashboard...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: '64px', marginBottom: '24px' }}>❌</div>
            <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#f87171', marginBottom: '16px' }}>
              Verification Failed
            </h1>
            <p style={{ color: '#9ca3af', marginBottom: '24px' }}>{message}</p>
            <button
              onClick={goToDashboard}
              style={{
                backgroundColor: '#D4AF37', color: '#000', padding: '12px 24px',
                borderRadius: '8px', fontWeight: '600', border: 'none', cursor: 'pointer',
                fontSize: '16px', transition: 'opacity 0.2s'
              }}
              onMouseOver={(e) => (e.currentTarget.style.opacity = '0.8')}
              onMouseOut={(e) => (e.currentTarget.style.opacity = '1')}
            >
              Go to Dashboard
            </button>
          </>
        )}
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

